import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const DURATION = 8
const POINT = 0.5
const POINTS_AT = 0.2

let mm

const format = value => Math.round(value).toLocaleString('en-GB')

export const valueComparison = () => {

	if (mm) mm.revert()

	let sections = document.querySelectorAll('[data-animation="value-comparison"]')

	if (!sections.length) return

	mm = gsap.matchMedia()

	mm.add({
		isDesktop: '(min-width: 961px)',
		motion: '(prefers-reduced-motion: no-preference)',
	}, context => {

		let { isDesktop, motion } = context.conditions

		// Reduced motion: the markup already holds the final state
		if (!motion) return

		let restore = []

		sections.forEach(section => {

			let chartCard = section.querySelector('.chart-card'),
				adviceCard = section.querySelector('.advice-card'),
				plot = section.querySelector('.plot'),
				amount = section.querySelector('.amount'),
				points = section.querySelectorAll('.point')

			let tl = gsap.timeline({
				defaults: { ease: 'power1.inOut' },
				scrollTrigger: {
					trigger: chartCard,
					start: 'top 70%',
					toggleActions: 'play none none none',
				},
			})

			if (plot) {
				tl.fromTo(plot, { clipPath: 'inset(0% 100% 0% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: DURATION }, 0)
			}

			let target = amount ? parseInt(amount.textContent.replace(/[^\d]/g, ''), 10) : NaN

			if (!isNaN(target)) {
				let counter = { value: 0 }

				amount.textContent = format(0)
				restore.push(() => amount.textContent = format(target))

				tl.to(counter, {
					value: target,
					duration: DURATION,
					onUpdate: () => amount.textContent = format(counter.value),
				}, 0)
			}

			if (!points.length) return

			// Spread the items across the climb so the last lands with the final value
			let reveal = {
				autoAlpha: 1,
				y: 0,
				duration: POINT,
				ease: 'power2.out',
				stagger: (DURATION - POINTS_AT - POINT) / Math.max(points.length - 1, 1),
			}

			if (isDesktop) {
				tl.fromTo(points, { autoAlpha: 0, y: 20 }, reveal, POINTS_AT)
			} else {
				// Stacked: the advice card sits below the chart, so reveal it when it's on screen
				gsap.fromTo(points, { autoAlpha: 0, y: 20 }, {
					...reveal,
					scrollTrigger: {
						trigger: adviceCard,
						start: 'top 70%',
						toggleActions: 'play none none none',
					},
				})
			}
		})

		return () => restore.forEach(fn => fn())
	})
}

export default () => { }
